import React from "react";
import { Image, Responsive } from "semantic-ui-react";
import { NJLOGO } from "../Assets";

const ResponsiveLogoTitle: React.FunctionComponent = () => {
    return (
        <div>
            <Responsive {...Responsive.onlyMobile}>
            <Image centered spaced style={{paddingTop: "220px"}}
                children={NJLOGO} className="logo" alt="logo"  />
            </Responsive>
            <Responsive minWidth={Responsive.onlyTablet.minWidth}>
            <Image centered spaced style={{paddingTop: "70px"}}
                children={NJLOGO} className="logo" alt="logo"  />
            </Responsive>
            <h1>Workers Comp Inquiry Portal</h1>
            <br/>
        </div>
    );
};

export default ResponsiveLogoTitle;
